<template>
  <b-modal
    v-model="show_"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    dialog-class="p-0-modal-component"
    hide-footer
  >
    <template v-slot:modal-title>
      {{ title }}
    </template>

    <div class="card m-0 border-0">
      <div class="position-relative">
        <div class="card-header header-elements-inline">
          <h6 class="card-title mb-0">
            {{ $t(`${tt}.description`) }}
          </h6>
        </div>

        <ul class="media-list media-list-linked media-list-bordered">
          <user-one
            v-for="user in users"
            :key="`user-${user.id}`"
            :user="user"
            @click="onSelect(user.id)"
          />

          <li class="media font-weight-semibold bg-light py-1">
            {{ $t(`${tt}.other_options`) }}
          </li>

          <li>
            <a
              href="#"
              class="media"
              @click.prevent="onSelect('reset')"
            >
              <div class="mr-3">
                <img
                  src="@/static/user__1_.png"
                  class="rounded-circle avatar-sm"
                  alt
                >
              </div>
              <div class="media-body">
                <h6 class="media-title text-primary">
                  {{ $t(`${tt}.unassigned_title`) }}
                </h6>
                {{ $t(`${tt}.unassigned_description`) }}
              </div>
            </a>
          </li>
        </ul>

        <widget-loader v-if="loading || disabled" />
      </div>
    </div>
  </b-modal>
</template>

<script>
import ModalShowMixins from "@/mixins/ModalShowMixins";
import WidgetLoader from '@/components/Widget/WidgetLoader';
import UserOne from '@/components/Room/Header/Reassign/UserReassignHeaderRoomComponents';

export default {
  components: {
    WidgetLoader,
    UserOne,
  },
  mixins: [ModalShowMixins],
  props: {
    phoneNumbers: {
      type: Array,
      default: () => ([]),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tt: 'room.header.reassign.modal',
      loading: false,
    };
  },
  computed: {
    title() {
      return this.$t(`${this.tt}.title`, {numbers: this.phoneNumbers.join(', ')})
    },
    users() {
      return Object.values(this.$store.state.user.data)
    },
  },
  methods: {
    onSelect(user_id) {
      this.$emit('select', user_id);
    },
  },
}
</script>

<style>
.media {
  margin-top: 1.25rem
}

.media.card-body, .media:first-child {
  margin-top: 0
}

.media-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0
}

.media-title {
  margin-bottom: .125rem
}

.img-preview {
  max-height: 5rem
}

.media-list-bordered .media {
  margin-top: 0;
  padding: 1rem 1.25rem;
  border-top: 1px solid #ddd
}

.media-list-linked .media {
  padding: 1rem 1.25rem
}

.media-list-linked li.media {
  margin-top: 0;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd
}

.media-list-linked.media-list-bordered li.media {
  border-bottom: 0
}

.media-list-linked a.media {
  color: inherit;
  transition: all .15s ease-in-out
}

@media screen and (prefers-reduced-motion: reduce) {
  .media-list-linked a.media {
    transition: none
  }
}

.media-list-linked a.media:hover {
  background-color: rgba(0, 0, 0, .04)
}
</style>

<style scoped>
.card-header {
  background-color: transparent !important;
}
</style>
